import { Stack, Typography } from "@mui/material";

export default function SectionHeader({
  overline,
  title,
  subtitle,
  align = "center",
}) {
  return (
    <Stack spacing={1.25} sx={{ textAlign: align, mb: { xs: 4, md: 6 } }}>
      {overline && (
        <Typography
          variant="h3"
          sx={{ fontWeight: 800, color: "primary.main", letterSpacing: ".5px" }}
        >
          {overline}
        </Typography>
      )}
      {title && (
        <Typography
          variant="h2"
          sx={{ fontWeight: 900, fontSize: { xs: 24, md: 32 } }}
        >
          {title}
        </Typography>
      )}
      {subtitle && <Typography color="text.secondary">{subtitle}</Typography>}
    </Stack>
  );
}
